import styled from 'styled-components';
import { FormFields } from '~/components/FormFields';
import { Form, Accordion, Button } from 'semantic-ui-react';

export const StyledSelect = styled(FormFields.Select)`
  width: 100%;
`;

export const RecipientsAccordion = styled(Accordion)`
  &&.styled {
    width: 100%;
  }

  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const RecipientsAccordionTitle = styled(Accordion.Title)`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const SendButton = styled(Button)`
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  padding: 0.75rem 1.75rem  !important;
  margin-top: 2rem;
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  background-color: #1a3175 !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  &:hover {
    color: #ffffff !important;
    background-color: rgb(26, 49, 117, 0.9) !important;
  }
`;

export const SaveDraftButton = styled(Button)`
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  padding: 0.75rem 1.75rem  !important;
  margin-top: 2rem;
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 1px #1a3175 inset !important;
  color: #1a3175 !important;

  &:hover {
    color: #ffffff !important;
    background-color: rgb(26, 49, 117, 0.9) !important;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 2rem;
`;

export const StyledLabel = styled.label`
  display: block;
  font-weight: 700;
  color: #5e6672;
  font-size: 16px;
  margin-bottom: 0.5rem;
`;

